/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "minHeight"];
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { forwardRef } from 'react';
var minHeightComponentStyles = null;
export var MinHeightContainer = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    minHeight = _ref.minHeight,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    ,
    className: ax(["_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li", className])
  }, props, {
    style: _defineProperty({}, '--link-picker-min-height', minHeight)
  }));
});